import { Link } from "react-router-dom";
import { ApiError } from "../lib/api";
import { Icon } from "./Icon";

const accountErrors = new Set(["VENICE_CONNECTION_REQUIRED", "VENICE_RECONNECT_REQUIRED"]);
const fundingErrors = new Set(["VENICE_FUNDS_REQUIRED", "VENICE_KEY_LIMIT_REACHED"]);

export function ProviderErrorNotice({ error, onRetry }: { error: unknown; onRetry?: (() => void) | undefined }) {
  if (!error) return null;
  const apiError = error instanceof ApiError ? error : null;
  const message = error instanceof Error ? error.message : "The request could not be completed.";
  return (
    <div className="provider-error" role="alert">
      <Icon name="alert" size={17}/>
      <div><strong>{apiError?.code === "VENICE_FUNDS_REQUIRED" ? "More Venice Credits needed" : "Venice request not completed"}</strong><span>{message}</span></div>
      {apiError && accountErrors.has(apiError.code) && <Link className="button button--ghost button--small" to="/app/profile?tab=venice">Open connection</Link>}
      {apiError && fundingErrors.has(apiError.code) && <a className="button button--ghost button--small" href="https://venice.ai/settings/api" target="_blank" rel="noreferrer">Open Venice <Icon name="external" size={13}/></a>}
      {onRetry && (!apiError || apiError.status === 429 || apiError.status >= 500) && <button className="button button--ghost button--small" onClick={onRetry}>Try again</button>}
    </div>
  );
}
